(function () {
  function setupExpandable(expandable) {
    if (expandable.dataset.specificationsReady === 'true') return;

    var card = expandable.closest('.jsd-product-specifications__card');
    var content = expandable.querySelector('.jsd-product-specifications__card-content');
    var button = card && card.querySelector('[data-product-specifications-toggle]');
    var label = button && button.querySelector('[data-product-specifications-toggle-label]');

    if (!card || !content || !button || !label) return;

    expandable.dataset.specificationsReady = 'true';

    function refreshHeight() {
      expandable.style.setProperty('--expanded-height', content.scrollHeight + 'px');
      if (!expandable.classList.contains('is-expanded')) {
        var collapsedHeight = parseFloat(window.getComputedStyle(expandable).getPropertyValue('--collapsed-specifications-height'));
        var isNotOverflowing = !Number.isFinite(collapsedHeight) || content.scrollHeight <= collapsedHeight + 2;
        expandable.classList.toggle('is-not-overflowing', isNotOverflowing);
        button.hidden = isNotOverflowing;
      }
    }

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      expandable.classList.toggle('is-expanded', !expanded);
      label.textContent = expanded ? 'Show Full Details' : 'Show Less';
      refreshHeight();
    });

    refreshHeight();
    window.addEventListener('resize', refreshHeight);
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-product-specifications-expandable]').forEach(setupExpandable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
